import { useCurrentStateAndParams } from "@uirouter/react";

import type { WebSource } from "app/components/filters-bar/websource-filter/WebSourceFilter.types";
import type { SearchAdvertisingParamKeys } from "single-spa/react-app/config/solutions25/adIntelligence/searchAdvertising/searchAdvertisingRoutes.types";

type UseSearchAdvertisingDataAndParamsReturn = Record<
    Exclude<SearchAdvertisingParamKeys, "key" | "duration" | "country" | "webSource" | "isWWW">,
    string | undefined
> & {
    key: string;
    duration: string;
    keyword: string;
    country: number;
    webSource: WebSource;
    isWWW: string;
};

export const useSearchAdvertisingDataAndParams = (): UseSearchAdvertisingDataAndParamsReturn => {
    const { params } = useCurrentStateAndParams<UseSearchAdvertisingDataAndParamsReturn>();
    return params;
};
